import joi from 'joi';

import {
  PASSWORD_MIN_LENGTH,
  PASSWORD_RULE_LOWERCASE,
  PASSWORD_RULE_NUMBERS,
  PASSWORD_RULE_SPECIAL_CHARACTERS,
  PASSWORD_RULE_UPPERCASE,
} from '@src/features/auth/constants';

// Special characters supported by auth provider
const specialCharacterRegex = /[\^$*.\[\]{}()?"!@#%&\/\\,><':;|_~`=+\-]/;

export const passwordSchema = joi
  .string()
  .invalid(joi.ref('oldPassword'))
  .min(PASSWORD_MIN_LENGTH)
  .pattern(/[a-z]/, {
    name: PASSWORD_RULE_LOWERCASE,
  })
  .message(PASSWORD_RULE_LOWERCASE)
  .pattern(/[A-Z]/, {
    name: PASSWORD_RULE_UPPERCASE,
  })
  .message(PASSWORD_RULE_UPPERCASE)
  .pattern(/[0-9]/, {
    name: PASSWORD_RULE_NUMBERS,
  })
  .message(PASSWORD_RULE_NUMBERS)
  .pattern(specialCharacterRegex, {
    name: PASSWORD_RULE_SPECIAL_CHARACTERS,
  })
  .message(PASSWORD_RULE_SPECIAL_CHARACTERS);
